<div class="modal-header">
    <h5 class="title-box">
        <i class="app-icon-tag" style="margin-right: 8px"></i>
        Acesse sua conta para continuar
    </h5>
    <button type="button" class="close" data-dismiss="modal" (click)="closeModal.emit()">
        <i class="material-icons">close</i>
    </button>
</div>
<div class="modal-body">
    <p>
        Para realizar uma oferta, é necessário se identificar. Caso ainda não seja cadastrado, crie sua
        conta de forma rápida e segura.
    </p>
</div>
<div class="modal-footer">
    <button class="btn btn-primary btn-rounded btn-lg btn-block" (click)="redirectToLogin()">FAZER LOGIN</button>

    <div class="mt-3 text-center">
        <a [routerLink]="['/cadastro-comprador']" class="hover-underline">Não possui conta? Clique aqui e cadastre-se</a>
    </div>
</div>